import { BaseModel, HasId } from "./base";
import { DisplayName } from "../components/select/base-select-with-id.component";

export class PaymentType 
    extends BaseModel 
    implements DisplayName, HasId {

    get id(): string {
        return this.type;
    }

    get displayName(): string {
        return this.type;
    }

    public type: string;
    public receiver: string;

    constructor(json?: any) {
        super(json);
    }
}